import { BackendRoute } from '../../../config/index';
import { QueryKey } from '../../../constants/index';
import { useAppQuery } from '../../../hooks/use-app-query.hook';
import ApiService from '../../../services/api-service.util';

type HasTemplatesForPlanResponse = { hasTemplates: boolean };

export function useTemplatesForPlan(companyId: string, equityPlanId: string) {
  const { data, isPending } = useAppQuery<HasTemplatesForPlanResponse>({
    queryKey: [QueryKey.GET_TEMPLATES, 'has-for-plan', companyId, equityPlanId],
    queryFn: () =>
      ApiService.get<HasTemplatesForPlanResponse>(
        { endpoint: BackendRoute.TEMPLATES, routePath: ['has-for-plan'] },
        { queryParams: { companyId, equityPlanId } },
      ),
    enabled: Boolean(companyId && equityPlanId?.trim()),
  });

  const hasTemplatesForPlan = !equityPlanId?.trim()
    ? true
    : isPending
      ? true
      : (data?.hasTemplates ?? false);

  return { hasTemplatesForPlan, isPending };
}
